export default __webpack_public_path__ + "static/media/b_programas_sociales_small.05b7ba30.jpg";